import map from 'lodash/fp/map';

export const parseControlDeviceOperation = operation => operation;

export const parseControlDeviceOperations = operations => map(parseControlDeviceOperation, operations);
